/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskDistributions
 */
export interface ExecRiskDistributions {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    CYPaidAccomplishExemptPrpsAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    CYPdInExcessIncomeActivityAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    CYAdministrativeExpensePaidAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    ExemptUseAssetsAcquisPaidAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    QualifiedSetAsideAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    CYOtherDistributionsAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    CYTotalAnnualDistributionsAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    CYDistriAttentiveSuprtOrgAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributions
     */
    CYDistributableAsAdjustedAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskDistributions
     */
    CYDistributionYrRt?: string;
}

/**
 * Check if a given object implements the ExecRiskDistributions interface.
 */
export function instanceOfExecRiskDistributions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskDistributionsFromJSON(json: any): ExecRiskDistributions {
    return ExecRiskDistributionsFromJSONTyped(json, false);
}

export function ExecRiskDistributionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskDistributions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'CYPaidAccomplishExemptPrpsAmt': !exists(json, 'CYPaidAccomplishExemptPrpsAmt') ? undefined : json['CYPaidAccomplishExemptPrpsAmt'],
        'CYPdInExcessIncomeActivityAmt': !exists(json, 'CYPdInExcessIncomeActivityAmt') ? undefined : json['CYPdInExcessIncomeActivityAmt'],
        'CYAdministrativeExpensePaidAmt': !exists(json, 'CYAdministrativeExpensePaidAmt') ? undefined : json['CYAdministrativeExpensePaidAmt'],
        'ExemptUseAssetsAcquisPaidAmt': !exists(json, 'ExemptUseAssetsAcquisPaidAmt') ? undefined : json['ExemptUseAssetsAcquisPaidAmt'],
        'QualifiedSetAsideAmt': !exists(json, 'QualifiedSetAsideAmt') ? undefined : json['QualifiedSetAsideAmt'],
        'CYOtherDistributionsAmt': !exists(json, 'CYOtherDistributionsAmt') ? undefined : json['CYOtherDistributionsAmt'],
        'CYTotalAnnualDistributionsAmt': !exists(json, 'CYTotalAnnualDistributionsAmt') ? undefined : json['CYTotalAnnualDistributionsAmt'],
        'CYDistriAttentiveSuprtOrgAmt': !exists(json, 'CYDistriAttentiveSuprtOrgAmt') ? undefined : json['CYDistriAttentiveSuprtOrgAmt'],
        'CYDistributableAsAdjustedAmt': !exists(json, 'CYDistributableAsAdjustedAmt') ? undefined : json['CYDistributableAsAdjustedAmt'],
        'CYDistributionYrRt': !exists(json, 'CYDistributionYrRt') ? undefined : json['CYDistributionYrRt'],
    };
}

export function ExecRiskDistributionsToJSON(value?: ExecRiskDistributions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'CYPaidAccomplishExemptPrpsAmt': value.CYPaidAccomplishExemptPrpsAmt,
        'CYPdInExcessIncomeActivityAmt': value.CYPdInExcessIncomeActivityAmt,
        'CYAdministrativeExpensePaidAmt': value.CYAdministrativeExpensePaidAmt,
        'ExemptUseAssetsAcquisPaidAmt': value.ExemptUseAssetsAcquisPaidAmt,
        'QualifiedSetAsideAmt': value.QualifiedSetAsideAmt,
        'CYOtherDistributionsAmt': value.CYOtherDistributionsAmt,
        'CYTotalAnnualDistributionsAmt': value.CYTotalAnnualDistributionsAmt,
        'CYDistriAttentiveSuprtOrgAmt': value.CYDistriAttentiveSuprtOrgAmt,
        'CYDistributableAsAdjustedAmt': value.CYDistributableAsAdjustedAmt,
        'CYDistributionYrRt': value.CYDistributionYrRt,
    };
}

